import React, { Component } from 'react'
import $ from "jquery";
import Login from "../headerComponents/login"
import Signup from "../headerComponents/signup"

export default class LoginButtons extends Component {
    loginClick() {
        $(".loginPopUp").show();
        $(".loginForgotHide").show();
        $("#username").focus();
        $("#username").show();
        $("#password").hide();
        $("#btnSubmit").show();
        $("#btnLogin").hide();
        $("#otp").hide();
        $(".loginErrorMsg").text('');
        $("#resendOTP").hide();
        $("#btnOTPLogin").hide();
        $("#passwordShow").hide();
    }
    signUpClick() {
        $(".loginPopUp").hide();
        $(".signUpPopUp").show();
        $("#txtFirstName").focus();
        $("#passwordShow").hide();
    }
    render() {
        return (
            <div className="login-register btn login-register-top">
                
                <button class="gsa-login-btn mr-3" onClick={() => this.loginClick()}>Login</button>
                <button class="gsa-reg-btn" onClick={() => this.signUpClick()}>Register</button>
                <div class="popupWrap loginPopUp">
                    <Login></Login>
                </div>
                <div class="popupWrap signUpPopUp">
                    <Signup></Signup>
                </div>
                
            </div>
        )
    }
}